import "@mantine/core/styles.css";
import "@mantine/carousel/styles.css";
import "@mantine/charts/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/notifications/styles.css";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { Provider } from "react-redux";

import store from "config/redux/index";
import CustomRouter from "config/router";
import DialogListener from "listeners/dialog";

import theme from "./config/theme";

function App() {
  return (
    <Provider store={store}>
      <MantineProvider theme={theme}>
        <Notifications position="top-right" />
        <DialogListener />
        <CustomRouter />
      </MantineProvider>
    </Provider>
  );
}

export default App;
